import React, { useState, useEffect } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import editIcon from "./../../../../../../Assets/icons/Un-Checkbox.svg";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";
import CustomTable from "../../../../../customComponents/CustomTable";
import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";
import validations from "../../../../../../helpers/validations";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";

const AddDiscount = () => {
  const [formData, setFormData] = useState({});
  const [productOptions, setProductOptions] = useState([]);
  const [discountTypeData, setDiscountTypeData] = useState([]);
  const [variantdd, setVariantDD] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const [discountValidation, setDiscountValidation] = useState("");
  const navigate = useNavigate();
  const [modelOptions, setModelOptions] = useState([]);
  const authToken = localStorage.getItem("authToken");
  // const businessPartnerId = 1; // Use the actual business_partner_id

  const [discountData, setDiscountData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const [discountIdValue, setDiscountIdValue] = useState();
  const [discountSpecificId, setSpecificDiscountId] = useState();

  useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async () => {
    try {
      const payload = {
        orderBy: "model_id desc",
        page: 0,
        pageSize: 100,
        // make_id: makeId,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post("/model/ddlmodel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setModelOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    fetchDiscountType();
  }, []);

  const fetchDiscountType = async () => {
    try {
      const payload = {
        orderBy: "discount_type_id desc",
        pageSize: 10,
        page: 0,
      };

      const response = await axiosInstance.post("/discounttype/list", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((data) => ({
        label: data.discount_type_name,
        value: data.discount_type_value,
      }));

      setDiscountTypeData(options);
    } catch (error) {
      console.error("Error fetching color options:", error);
    }
  };

  const fetchProductOptions = async () => {
    try {
      const payload = {
        orderBy: "product_id desc",
      };

      const response = await axiosInstance.post(
        "/product/ddlproduct",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));

      setProductOptions(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  const fetchVariantOption = async (productId) => {
    try {
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {
          business_partner_id: formData?.business_partner_id,
          product_id: productId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));

      setVariantDD(options);
    } catch (error) {
      console.error("Error fetching warranty options:", error);
    }
  };

  // useEffect(() => {
  //   fetchProductOptions();
  // }, []);

  // useEffect(() => {
  //   if (formData.productName && formData.productName) {
  //     fetchVariantOption(formData.productName);
  //   }
  // }, [formData.productName]);

  // useEffect(() => {
  //   if (formData?.variant_id) {
  //     const fetchVariantBasedDetails = async () => {
  //       try {
  //         const response = await axiosInstance.post(
  //           "/variant/ddlvariantbasedetails",
  //           {
  //             //business_partner_id: 1,
  //             variant_id: formData.variant_id,
  //           },
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${authToken}`,
  //             },
  //           }
  //         );

  //         const variantwisedata = response?.data?.data?.data[0];
  //         console.log("variantwisedata", variantwisedata);

  //         setFormData({
  //           ...formData,

  //           fuel: variantwisedata?.fuel_type_name,
  //           fuel_type_id: variantwisedata?.fuel_type_id,
  //           subproductName: variantwisedata?.subproduct_name,
  //           subproduct_id: variantwisedata?.subproduct_id,
  //           make: variantwisedata?.make_name,
  //           make_id: variantwisedata?.make_id,
  //           model: variantwisedata?.model_name,
  //           model_id: variantwisedata?.model_id,
  //           exshowroomprice: variantwisedata?.exshowroom_price,
  //           vehiclecolor: variantwisedata?.color_name,
  //           color_id: variantwisedata?.color_id,
  //         });
  //       } catch (error) {
  //         console.error("Error fetching variant options:", error);
  //       }
  //     };

  //     fetchVariantBasedDetails();
  //   }
  // }, [formData?.variant_id]);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      discount: "",
    }));
    console.log("formData<><><>", formData);

    if (formData.discount_type && formData.discount_type === "A") {
      setDiscountValidation(formData.exshowroomprice);
      //alert((formData.exshowroomprice)?.length)
    } else {
      setDiscountValidation(2);
    }
    console.log(discountValidation, "discountValidation");
  }, [formData.discount_type]);

  const handleFormSubmit = async (formData) => {
    console.log("discounfromdate", formData);

    const errors = {};
    let isValid = true;

    VariantInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    // showCustomAlert({
    //   title: "Success",
    //   text: "Are you sure you want to create a record in Discount.",
    //   confirmButtonText: "Discount created successfully.",
    //   icon: "success",
    //   confirmButtonText: "OK",
    // callback: async () => {

    const confirmation = await showAlert({
      title: "Confirmation",
      text: "Are you sure you want to create a record in Discount.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    if (!confirmation.isConfirmed) {
      return;
    }

    try {
      setLoading(true);
      const addOneDay = (date) => {
        const adjustedDate = new Date(date);
        adjustedDate.setDate(adjustedDate.getDate() + 1); // Add one day
        return adjustedDate.toISOString().split("T")[0];
      };

      const payload = {
        discount_name: formData.discount_name,
        model_id: formData.model_id,
        duration_months: formData.duration_months,
        status: formData.status ? 1 : 0,
      };

      const response = await axiosInstance.post("/discount/create", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      console.log("API Response:", response.data);
      const responseDataDiscountId =
        response?.data?.data?.responseData?.discount_id;
      console.log(responseDataDiscountId, "responseDAtaDiscountId");
      // navigate("/admin/manage-product/discount");
      setDiscountIdValue(responseDataDiscountId);
      // if (response.status === 200) {
      // navigate("/admin/manage-product/discount"); // Navigate after user clicks OK
      if (response.status === 200) {
        await showAlert({
          title: "Success",
          text: "Discount created successfully.",
          icon: "success",
          confirmButtonText: "OK",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        // navigate("/admin/manage-product/discount");
      }
      // }
    } catch (error) {
      console.error("Error submitting form:", error);
      const errorMessage = error.response?.data?.message;

      showErrorAlert({
        title: "Something went wrong",
        text:
          errorMessage || "An error occurred while processing your request.",
        callback: () => {
          // Optional: code to execute after confirming the alert
          console.log("Error alert confirmed");
        },
      });
    } finally {
      setLoading(false);
    }
    // },
    // });
  };

  const DiscountInputs = [
    {
      name: "min_quantity",
      label: "Minimum Quantity",
      type: "number",
      placeholder: "Enter Min Quantity",
      // options: warrantyOptions,
      required: true,
      gridClass: "col-lg-4",
      validation: validations.quantity({ required: true }),
      // validation: {
      //   required: true,
      //   minLength: 1,
      //   maxLength: 3,

      //   // Positive integers, no leading zeros
      //   pattern: /^[1-9][0-9]{0,2}$/,

      //   message:
      //     "Minimum Quantity must be a positive number with 1–3 digits and no leading zeros",
      // },
    },
    {
      name: "max_quantity",
      label: "Maximum Quantity",
      type: "number",
      placeholder: "Enter Max Quantity",
      // options: warrantyOptions,
      required: true,
      gridClass: "col-lg-4",
      validation: validations.quantity({ required: true }),
      // validation: {
      //   required: true,
      //   minLength: 1,
      //   maxLength: 3,

      //   // Positive integers, no leading zeros
      //   pattern: /^[1-9][0-9]{0,2}$/,

      //   message:
      //     "Max Quantity must be a positive number with 1–3 digits and no leading zeros",
      // },
    },
    {
      name: "discount",
      label: "(₹) Discount",
      type: "number",
      // options: warrantyOptions,
      placeholder: "Enter Discount (rupees)",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.price({
        required: true,
        maxLength: 5,
        decimalPlace: 0,
      }),
      // validation: {
      //   minLength: 2,
      //   maxLength: 5,
      //   required: true,
      //   pattern: /^[1-9][0-9]*$/,
      //   message: "Please enter a positive number with no leading zeros",
      // },
    },
  ];

  const VariantInputs = [
    {
      name: "discount_name",
      label: "Campaign Name",
      type: "text",
      placeholder: "Enter Discount Name",
      // disabled: true,
      //options: fuelOptions,
      required: true,
      gridClass: "col-lg-4",
      validation: validations.batteryBrandName({ required: true }),
    },
    {
      name: "model_id",
      label: "Model",
      placeholder: "Model",
      type: "multiselectdropdown",
      // disabled: true,
      options: modelOptions,
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,

        // pattern: /^\d+(\.\d{1,2})?$/, // Allows up to 2 decimal places
        // message: "Only digits  are allowed",
      },
    },
    {
      name: "duration_months",
      label: "Duration (Months)",
      type: "text",
      // options: warrantyOptions,
      placeholder: "Enter the duration",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.duration({ required: true }),
      // validation: {
      //   required: true,
      //   minLength: 1,
      //   maxLength: 3,

      //   // Allows 1–9, 10–99, 100–599, 600; no leading zeros
      //   pattern: /^(?:[1-9]|[1-9][0-9]|[1-5][0-9]{2}|600)$/,

      //   message:
      //     "Duration must be a positive number between 1 and 600 with no leading zeros",
      // },
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",

      gridClass: "col-lg-4",
    },
  ];
  useEffect(() => {
    setFormData({ ...formData, discount_todate: "" });
  }, [formData?.discount_fromdate]);

  const VARIANT_TABLE_HEADERS = [
    // "Sr No.",
    // "Discount Id",
    "Min Qty",
    "Max Qty",
    "Discount Amount",
    // "Min Quantity",
    // "Status",
    "Action",
  ];

  const variantKeyMapping = {
    "Sr No.": "Sr No.",
    "Min Qty": "min_quantity",
    "Max Qty": "max_quantity",
    "Discount Amount": "amount",
    "Discount Fromdate": "discount_fromdate",
    "Discount Todate": "discount_todate",
    Discount: "discount",
    Status: "status",
    Action: [{ type: "edit", icon: editIcon, label: "Edit" }],
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // fetchDiscountList(newPage);
  };

  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    setSpecificDiscountId(rowData.id);
    getDetailsEdit(rowData.id);
    setIsEdit(true);
    // navigate(`${ROUTES_NAVIGATION.EDITDISCOUNTLIST}`, { state: { data: rowData } });
  };

  const getDetailsEdit = async (id) => {
    console.log(id, "getDetailsId");
    try {
      // setLoading(true)
      const response = await axiosInstance.get(`/subdiscount/edit/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const fetchedData = response.data?.data;
      console.log(fetchedData, "getEditData");

      setFormData((prevData) => ({
        ...prevData,
        discount: fetchedData?.amount,
        max_quantity: fetchedData?.max_quantity,
        min_quantity: fetchedData?.min_quantity,
      }));
    } catch (error) {
      console.error("Error fetching product list:", error);
    } finally {
      // setLoading(false)
    }
  };

  const handleFormSave = async (formData) => {
    const errors = {};
    let isValid = true;

    DiscountInputs.forEach((field) => {
      const value = formData[field.name];

      if (field.validation?.required && !value) {
        errors[field.name] = "This field is required";
        isValid = false;
        return;
      }

      if (
        value &&
        field.validation?.pattern &&
        !field.validation.pattern.test(value)
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
        return;
      }
    });

    if (
      formData.min_quantity &&
      formData.max_quantity &&
      Number(formData.max_quantity) < Number(formData.min_quantity)
    ) {
      errors.min_quantity =
        "Minimum Qty cannot be greater than Maximum Quantity";
      isValid = false;
    }

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    try {
      const payload = {
        min_quantity: formData.min_quantity,
        max_quantity: formData.max_quantity,
        amount: formData.discount,
        discount_id: discountIdValue,
        // status: 1
      };

      // const url = isEdit
      //   ?
      //   ``
      //   // `/podraftdetails/update/${draftId}`
      //   : "/subdiscount/create";

      const url = isEdit
        ? `/subdiscount/update/${discountSpecificId}`
        : "/subdiscount/create";

      const method = isEdit ? "patch" : "post";

      const response = await axiosInstance({
        method, // Dynamically set the HTTP method
        url,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status === 200) {
        setFormData((prev) => ({
          ...prev,
          min_quantity: "",
          max_quantity: "",
          discount: "",
        }));
        fetchTableList();
        // setIsEdit(false);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    if (discountIdValue) {
      fetchTableList();
    }
  }, [discountIdValue]);

  // fetching table data
  const fetchTableList = async (page = 0, pageSize = 10) => {
    try {
      // setLoading(true)
      const response = await axiosInstance.post(
        "/subdiscount/list",
        {
          discount_id: discountIdValue,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        // "Sr No.": index + 1 + page * pageSize,
        // variant_name: item.variant_name || "--",
        // // productimage: item.productimage || "--",
        // part_category_name: item.part_category_name || "--",
        // job_card_number: item.job_card_number || "--",
      }));

      setDiscountData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching product list:", error);
    } finally {
      // setLoading(false)
    }
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div
              className="backbutton mt-2 mb-2"
              // onClick={() => navigate("/admin/manage-product/discount")}
            >
              <img
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Add Campaign</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter Campaign Details
              </span>
              <DynamicForm
                formConfig={VariantInputs}
                formData={formData}
                setFormData={setFormData}
                exshowroomprice={formData?.exshowroomprice}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
              <div className="btncontainer mt-3">
                <button
                  className="submit-btn"
                  // disabled={
                  //   !isFormValid(VariantInputs, formData, validationErrors) ||
                  //   loading
                  // }
                  // style={buttonStyle(
                  //   VariantInputs,
                  //   formData,
                  //   validationErrors,
                  //   loading,
                  // )}
                  onClick={() => {
                    handleFormSubmit(formData);
                  }}
                >
                  {loading ? "Processing..." : "Submit"}
                </button>
              </div>
              <DynamicForm
                formConfig={DiscountInputs}
                formData={formData}
                setFormData={setFormData}
                exshowroomprice={formData?.exshowroomprice}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
              <div className="btncontainer mt-3">
                {/* <button
                  onClick={() => {
                    handleFormSave(formData);
                  }}
                  className="submit-btn"
                >
                  Save
                </button> */}

                <button
                  className="submit-btn"
                  onClick={() => {
                    if (!discountIdValue) {
                      // showCustomAlert({
                      //   title: "Incomplete Details",
                      //   text: "Please complete the campaign details first.",
                      //   icon: "warning",
                      //   confirmButtonText: "OK",
                      // });
                      showAlert({
                        title: "Incomplete Details",
                        text: "Please submit the campaign details first before adding discount details.",
                        icon: "warning",
                        showCancelButton: false,
                        confirmButtonText: "Ok",
                        // cancelButtonText: "Cancel",
                      });
                      return;
                    }

                    handleFormSave(formData);
                  }}
                >
                  Save
                </button>
              </div>
            </div>

            <CustomTable
              data={discountData}
              headers={VARIANT_TABLE_HEADERS}
              keyMapping={variantKeyMapping}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onEdit={handleEdit}
              totalRecords={totalRecords}
              isADDcomplainTable="true"
            />
          </>
        )}
      </div>
    </>
  );
};

export default AddDiscount;
